import { useMutation, useQueryClient } from '@tanstack/react-query';
import { configApi } from '../../configApi';
import { IPPPIQDocument } from './types';

interface IUploadPayload {
  registrationId: string;
  file: File;
}

const uploadPPPIQDocument = async ({ registrationId, file }: IUploadPayload): Promise<IPPPIQDocument> => {
  const formData = new FormData();
  formData.append('files', file);
  formData.append('registration_id', registrationId);

  const response = await configApi.post<IPPPIQDocument>('registration/pppiq/upload/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const useUploadPPPIQDocument = (registrationId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => uploadPPPIQDocument({ registrationId, file }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['pppiq_documents', registrationId] });
    },
  });
};
